import React from 'react';
import PartnersContainer from './PartnerrsContainer';
import Partner from './Partner';
import './Partner.css';
import KTU_LOGO_LT from '../../resources/images/KTU-LT.svg';
import KTU_LOGO_EN from '../../resources/images/KTU-EN.svg';
import VGTU_LOGO_LT from '../../resources/images/VGTU-LT.svg';
import VGTU_LOGO_EN from '../../resources/images/VGTU-EN.svg';
import KK_LOGO from '../../resources/images/KK.svg';

export default (props) => {
    return (
        <PartnersContainer title={props.lang.partners_label}>
            <Partner image={props.selectedLanguage === "lithuanian"? KTU_LOGO_LT : KTU_LOGO_EN} url={() => window.location.href="https://www.ktu.edu"}/>
            <Partner image={props.selectedLanguage === "lithuanian"? VGTU_LOGO_LT : VGTU_LOGO_EN} url={() => window.location.href="https://www.vgtu.lt"}/>
            <Partner image={KK_LOGO} url={() => window.location.href="https://www.kaunokolegija.lt/"}/>
        </PartnersContainer>
    )
}


// WEBPACK FOOTER //
// ./src/components/partners/index.jsx